import Vue from 'vue';
import App from './App';
import store from './store/store';

import hu from './errormessages.json';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import VueToastify from 'vue-toastification';
import VueCurrencyFilter from 'vue-currency-filter';
import VueCurrencyInput from 'vue-currency-input';

import 'vue-toastification/dist/index.css';

import {library} from '@fortawesome/fontawesome-svg-core';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import VueGtm from '@gtm-support/vue2-gtm';
import Maska from 'maska';
import VueNumberFormat from '@coders-tm/vue-number-format';

import {
  ValidationProvider,
  ValidationObserver,
  localize,
  setInteractionMode,
} from 'vee-validate/dist/vee-validate.full';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(Maska);
Vue.use(VueNumberFormat, {precision: 4});

localize('hu', hu);
setInteractionMode('eager');

import axios from 'axios';

window.axios = axios;
//axios.defaults.baseURL = window.eqform.baseURL || 'https://test.nopa.hu/eqformexecutor'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

Vue.config.productionTip = false;

localStorage.clear();

Vue.use(VueToastify, {
  transition: 'Vue-Toastification__fade',
  maxToasts: 20,
  newestOnTop: true,
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  closeButton: 'button',
  icon: true,
});

Vue.use(VueCurrencyFilter, {
  symbol: 'Ft',
  thousandsSeparator: ' ',
  fractionCount: 0,
  symbolPosition: 'back',
  symbolSpacing: true,
});

window.currencyInputOptions = {
  currency: null,
  locale: 'hu',
  allowNegative: false,
  valueAsInteger: true,
  precision: 0,
};

Vue.use(VueCurrencyInput, {
  globalOptions: window.currencyInputOptions,
});

library.add(faSpinner);
Vue.component('FontAwesomeIcon', FontAwesomeIcon);

if (window.eqform.gtmEnabled) {
  Vue.use(VueGtm, {
    id: 'GTM-M4JVMB8V', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    nonce: '2726c7f26c', // Will add `nonce` to the script tag
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  });
}

import './validations';

new Vue({
  render: (h) => h(App),
  store,
}).$mount('#app');
